import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "../../../components/Layout";
import ArrowButton from "../../../components/ArrowButton";

export default class PaginaSucessoConsumidor extends Component {

    componentDidMount() {
        document.title = "Site Blindado - Página de Sucesso";
    }

    render() {
        return (
            <Layout>
                <div className="section-height-100-center products-sess1">
                    <Container>
                        <Row className="h-100 justify-content-center align-items-center">
                            <Col xs={12} md={6}>
                                <h3 className="font-black mb-5">Obrigada pelo seu depoimento!</h3>
                                <h6 className="mb-5"><strong>Ficamos felizes em receber seu feedback sobre os nossos serviços e produtos!</strong> Em breve, nossa equipe entrará em contato com você. Conte sempre com a Site Blindado para tornar todas as suas aplicações web seguras!</h6>
                                <ArrowButton link="/" type="green" side="left" text="Voltar para home" />
                            </Col>
                            <Col xs={12} md={6}>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Layout>
        );
    }
}